export enum FrequentlyAskedQuestionsTab {
  COMMON = 'common',
  PATIENT = 'patient'
}
